import { BaseLayout, EmptyLayout } from "components/BaseLayout";

export const baseLayout = (Element: () => React.ReactElement, params?: { showBack: boolean }) => (
  <BaseLayout {...params}>
    <Element />
  </BaseLayout>
);

export const emptyLayout = (Element: () => React.ReactElement, showHeader?: boolean) => (
  <EmptyLayout showHeader={showHeader}>
    <Element />
  </EmptyLayout>
);
